import type { FundingResult } from '@common/interfaces/api/fundingResultsApi';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/finance/fundingResults';

export async function findFundingResultByProcessNumber(
    processNumber: number,
    signal: AbortSignal
): Promise<FundingResult | undefined> {
    const url = `${baseUrl}/${processNumber}`;

    const result = await fetchJson({ method: 'GET', signal, url });

    return result?.json?.fundingResult;
}
